"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertDependency = void 0;
const convertDependency = (dep, eventFieldMap) => {
  if (dep.version === 'v2') {
    return dep;
  }
  // let's clone the dependency because we are going to mutate the critiera
  const res = JSON.parse(JSON.stringify(dep));
  res.criteria.forEach(item => {
    if (!item.field?.id) return;
    const isEventField = ['Event.start', 'Event.end', 'Event.name'].includes(item.field.id);
    if (isEventField) {
      const idParts = item.field.id.split('.');
      if (eventFieldMap && eventFieldMap[idParts[1]]) {
        item.field.id = `Event_${eventFieldMap[idParts[1]]}`;
      } else {
        item.field.id = `Event_${idParts[1]}`;
      }
    } else {
      item.field.id = `Participant_${item.field.id}`;
    }
  });
  return {
    ...res,
    id: dep.id,
    name: res.name,
    version: 'v2',
    criteria: [res.criteria]
  };
};
exports.convertDependency = convertDependency;
